import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=37ca459d&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=ts"
export * from "./FAQ.vue?vue&type=script&lang=ts"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=37ca459d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca459d",
  null
  
)

export default component.exports